import {
  useUpdateAgentAgentUpdatePostMutation,
  type AgentInfo,
  type UpdateAgentData,
} from '@shared/api';

export const useUpdateAgent = (onError?: () => void) => {
  const [updateAgentMutation, { isLoading }] = useUpdateAgentAgentUpdatePostMutation();

  const updateAgent = async (agentId: number, values: UpdateAgentData): Promise<AgentInfo> => {
    try {
      return await updateAgentMutation({
        agentId,
        updateAgentData: values,
      }).unwrap();
    } catch {
      onError?.();
      throw new Error();
    }
  };

  return { updateAgent, isLoading };
};
